import { render, staticRenderFns } from "./ResourcesWidget.vue?vue&type=template&id=f58d8666&"
import script from "./ResourcesWidget.vue?vue&type=script&lang=js&"
export * from "./ResourcesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports